import SubscriptionList from './SubscriptionList';
import styles from './subscription.module.css';

const SubscriptionDashboard = () => (
  <div className={styles.dashboardContainer}>
    <div className={styles.pageHeader}>
      <div>
        <h1 className={styles.mainTitle}>Gestion des Abonnements</h1>
      </div>
      <button
        type="button"
        className={styles.subscribePackageButton}
        disabled
        title="La souscription en ligne sera disponible prochainement"
      >
        Souscrire un package
      </button>
    </div>

    <SubscriptionList />
  </div>
);

export default SubscriptionDashboard;
